import { TRootState } from "store";
import { IListInvitationState } from "./invitations.types";

export const getInvitationsSelector = (state: TRootState): IListInvitationState => state.invitations;
